import {
  convertEventSelectToTarget,
  formatDataToLabelValue,
  FormFeedBack,
  Select,
} from '@repo/ui';
import { CpfInput } from 'adasi_components';
import { FormikProps } from 'formik';
import { Button, Card, Col, Input, Label, Row, Spinner } from 'reactstrap';

interface TceFiltersValues {
  studentCpf: string;
  studentName: string;
  group: Array<{ label: string; value: string }>;
  local: Array<{ label: string; value: string }>;
  entity: Array<{ label: string; value: string }>;
  course: Array<{ label: string; value: string }>;
}

interface TceFiltersProps {
  isSearching?: boolean;
  loadingReportSelectCourse: boolean;
  loadingInternshipLocations: boolean;
  loadingReportSelectOrganization: boolean;
  validation: FormikProps<TceFiltersValues>;
  groupsUser: Array<{ id: string; nome: string }>;
  coursesUser: Array<{ id: string; nome: string }>;
  organizationsUser: Array<{ id: string; nome: string }>;
  internshipLocationsSelectOptions: Array<{ id: string; nome: string }>;
  onEntityChange?: (value: unknown) => void;
  onCourseChange?: (value: unknown) => void;
}

export const TceFilters = ({
  validation,
  groupsUser,
  coursesUser,
  organizationsUser,
  isSearching = false,
  loadingReportSelectCourse,
  loadingInternshipLocations,
  loadingReportSelectOrganization,
  internshipLocationsSelectOptions,
  onEntityChange,
  onCourseChange,
}: TceFiltersProps) => {
  const handleEntityChange = (e: unknown) => {
    validation.handleChange(
      convertEventSelectToTarget('entity', e as never) as never,
    );
    validation.setFieldValue('course', []);
    validation.setFieldValue('group', []);
    validation.setFieldValue('local', []);

    onEntityChange?.(e);
  };

  const handleCourseChange = (e: unknown) => {
    validation.handleChange(
      convertEventSelectToTarget('course', e as never) as never,
    );
    validation.setFieldValue('group', []);
    validation.setFieldValue('local', []);

    onCourseChange?.(e);
  };

  return (
    <Card className="p-3 mb-3">
      <Row className="g-2">
        <Col xs={12} md={4}>
          <Label htmlFor="entity" className="form-label">
            Organização:
          </Label>
          <Select
            isClearable
            isMulti
            isLoading={loadingReportSelectOrganization}
            id="entity"
            name="entity"
            placeholder="Todas as Organizações"
            value={validation.values.entity}
            onChange={handleEntityChange}
            invalid={!!(validation.touched && validation.errors?.entity)}
            onBlur={validation.handleBlur}
            options={formatDataToLabelValue(
              organizationsUser as never,
              'id',
              'nome',
            )}
          />
          <FormFeedBack
            error={validation.errors?.entity as string}
            isInvalid={!!(validation.touched && validation.errors?.entity)}
          />
        </Col>

        <Col xs={12} md={4}>
          <Label htmlFor="course" className="form-label">
            Curso:
          </Label>
          <Select
            isMulti
            isClearable
            isLoading={loadingReportSelectCourse}
            isDisabled={loadingReportSelectCourse}
            id="course"
            name="course"
            placeholder="Todos os Cursos"
            value={validation.values.course}
            onChange={handleCourseChange}
            onBlur={validation.handleBlur}
            options={formatDataToLabelValue(coursesUser as never, 'id', 'nome')}
          />
        </Col>

        <Col xs={12} md={4}>
          <Label htmlFor="group" className="form-label">
            Grupo:
          </Label>
          <Select
            isMulti
            isClearable
            id="group"
            name="group"
            placeholder="Todos os Grupos"
            value={validation.values.group}
            onChange={(e) => {
              validation.handleChange(convertEventSelectToTarget('group', e));
            }}
            onBlur={validation.handleBlur}
            options={formatDataToLabelValue(groupsUser as never, 'id', 'nome')}
          />
        </Col>

        <Col xs={12} md={4}>
          <Label htmlFor="local" className="form-label">
            Local de Estágio:
          </Label>
          <Select
            isMulti
            isClearable
            isLoading={loadingInternshipLocations}
            isDisabled={
              validation.values.entity.length === 0 &&
              validation.values.course.length === 0 &&
              validation.values.group.length === 0
            }
            id="local"
            name="local"
            placeholder={'Todos os Locais'}
            value={validation.values.local}
            onChange={(e) => {
              validation.handleChange(convertEventSelectToTarget('local', e));
            }}
            onBlur={validation.handleBlur}
            options={formatDataToLabelValue(
              internshipLocationsSelectOptions as never,
              'id',
              'nome',
            )}
          />
        </Col>

        <Col xs={12} md={4}>
          <Label htmlFor="studentName" className="form-label">
            Nome do Estudante:
          </Label>
          <Input
            type="text"
            id="studentName"
            name="studentName"
            placeholder="Digite o nome"
            value={validation.values.studentName}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
          />
        </Col>
        <Col xs={12} md={4}>
          <Label htmlFor="studentCpf" className="form-label">
            CPF do Estudante:
          </Label>
          <CpfInput
            name="studentCpf"
            inputId="studentCpf"
            placeholder="Digite o CPF"
            value={validation.values.studentCpf}
            handleChange={validation.handleChange}
            onBlur={validation.handleBlur}
            className="form-control"
            style={{
              fontFamily: 'Poppins',
            }}
          />
        </Col>
        <div className="d-flex justify-content-end mt-4">
          <Col xs={12} md={2} className="">
            <Button
              color="primary"
              className="w-100"
              disabled={
                loadingReportSelectCourse ||
                loadingReportSelectOrganization ||
                isSearching
              }
              onClick={() => {
                validation.handleSubmit();
              }}
            >
              Pesquisar
              {(loadingReportSelectCourse ||
                loadingReportSelectOrganization ||
                isSearching) && <Spinner className="ms-2" size="sm" />}
            </Button>
          </Col>
        </div>
      </Row>
    </Card>
  );
};
